import { render, staticRenderFns } from "./ChatBotLLMList.vue?vue&type=template&id=13554174&scoped=true"
import script from "./ChatBotLLMList.vue?vue&type=script&lang=js"
export * from "./ChatBotLLMList.vue?vue&type=script&lang=js"
import style0 from "./ChatBotLLMList.vue?vue&type=style&index=0&id=13554174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13554174",
  null
  
)

export default component.exports